import React from 'react';
import img1 from '../../assets/img/home3/about-1.webp';
import img3 from '../../assets/img/home3/about-3.webp';
import img2 from '../../assets/img/home3/about-2.webp';
import ProcessContent from './ProcessContent';
import ProcessGrid2 from './ProcessGrid2';

function Process2() {
    return (
        <section className="promo-featured-wrapper section-padding">
            <div className="container">
                <div className="row align-center">
                    <div className="col-xl-5 col-12 text-center">
                        <ProcessGrid2 img1={img1} img2={img2} img3={img3} />
                    </div>
                    <div className="col-xl-7 col-12 mt-5 mt-xl-0">
                        <div className="block-contents ml-xl-5 ml-50">
                            <div className="section-title-3-light">
                                <p className="pl-50 pr-50">Company Insights</p>
                                <h1>About CV. Kalimantan Jaya Diesel</h1>
                            </div>
                            <ProcessContent
                                heading="Founded in 2005, Serving Heavy Industry Across Indonesia."
                                text="CV. Kalimantan Jaya Diesel (KJD) is a proficient and professional supplier of heavy equipment parts and components. Headquartered in Banjarmasin, South Kalimantan, we supply genuine and quality replacement parts — sourced from Japan, the U.S.A., Brazil, Korea, and China — to customers across Indonesia. As an Authorised Dealer of Garrett Turbochargers, we are committed to fulfilling your needs with responsive service, reliable quality, and competitive prices."
                            />
                            <a href="/contact" className="theme-btn theme-3">
                                Contact Us
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Process2;
